import React, { useEffect, useState } from "react";
import { PageTitle, Panel, Table, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export default function CarbonTax() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { CL.getCarbonTax().then(setD).catch(() => {}); }, []);

  return (
    <div data-testid="carbontax-page">
      <PageTitle title={t("carbonTaxTitle")} subtitle={t("carbonTaxDesc")} />
      <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard testId="ctax-total" label={t("totalEmissions")} value={(d?.total_t ?? 0).toLocaleString()} sub={t("tCO2e")} />
      </div>
      <Panel>
        <Table head={[{ label: t("country") }, { label: t("price"), right: true }, { label: t("cost"), right: true }]}>
          {(d?.rows || []).map((r, i) => (
            <tr key={i} className="hover:bg-[#fafbf6]" data-testid={`ctax-row-${i}`}>
              <td className="px-4 py-3 font-medium text-[#1b2420]">{r.country}</td>
              <td className="px-4 py-3 text-right text-[#4b544c]">€ {r.price.toLocaleString()}</td>
              <td className="px-4 py-3 text-right font-medium text-[#14512f]">€ {r.cost_eur.toLocaleString()}</td>
            </tr>
          ))}
        </Table>
      </Panel>
    </div>
  );
}
